import {
    CrudBase
} from "../../crud";
import {
    BasicCrud
} from "../../../utils/interfaces/crud/imp/crud-basic";
import {
    ContentModel
} from "../../../models/content";


export class _ContentController extends CrudBase {
    createModel = ContentModel;
    loading = false;
    list = []
    // formData 
    constructor() {
        super({
            name: "content",
            modules: {
                crud: new BasicCrud()
            },
            model: ContentModel
        });
    }

    onReady() {
        this.actions = this.repo.content;
        this.getAllContent();
    }

    async getAllContent() {
        let response = await this.execute(this.actions.getAll, null)
        if (response.success) {
            this.list = response.data
        }
    }

    async onEdit(item) {
        console.log(this);
        this.app.$refs.contentCreateDialog.open(
            item,
            "Edit Content",
            (callback) => {
                console.log(callback);
                let response =  this.execute(this.actions.update, callback, `?id=${callback.id}`)
                console.log("[ON EDIT]",response);
                if (response.success) {
                    item = callback
                    
                }
            }
        );
    }
    delete(item) {
        this.app.$refs.confirmationDialog.showDialog({
            title: `Delete Content`,
            message: `Are you sure you wish to delete  ${item.title}?`,
            callback: "onDeleted",
            callbackData: item,
            controller: "content"
        });
    }

    async onDeleted(item) {

        let response = await this.execute(this.actions.delete, null, `?id=${item.id}`);
        if (response.success) {
            this.list.splice(this.list.indexOf(item), 1);
            this.app.$refs.snackbarAlert.show({
                colour: "success",
                text: "content successfully deleted"
              })
        }
    }




}
export const ContentController = new _ContentController();